import { a as i, r as f } from "./object-BCk-1c8T.js";
var s = {
  fetch: {
    headers: {},
    parseAs: "json"
  },
  cookies: {
    path: "/",
    sameSite: "Lax",
    secure: !1
  },
  announcer: {
    politeness: "polite",
    atomic: !0,
    delay: 16,
    clearDelay: 1e3
  },
  pageMeta: {},
  transitions: {
    skipOnReducedMotion: !1,
    classes: [],
    types: []
  },
  components: { prefix: "bq" }
}, r = (e) => {
  if (typeof Headers < "u" && e instanceof Headers) return new Headers(e);
  if (Array.isArray(e)) return e.map((n) => r(n));
  if (f(e)) {
    const n = {};
    for (const [a, o] of Object.entries(e)) n[a] = r(o);
    return n;
  }
  return e;
}, t = r(s), d = (e) => (t = r(i(s, t, e)), c()), c = () => r(t);
export {
  c as n,
  d as t
};

//# sourceMappingURL=config-DhT9auRm.js.map